import { sp, RenderListDataOptions } from "@pnp/sp";
import memoize from "lodash-es/memoize";
import { configuration } from "./config.js";

export default memoize(() =>
  configuration.fakeData
    ? Promise.resolve({})
    : sp.web.lists
        .getByTitle(window["_spPageContextInfo"].listTitle)
        .renderListDataAsStream({
          RenderOptions: RenderListDataOptions.ListData,
          ViewXml: String.format(
            configuration.tenute.query,
            window["_spPageContextInfo"].pageItemId
          )
        })
        .then(res => (res.Row.length > 0 ? res.Row[0] : null))
);
